import { render } from "./Thought.vue?vue&type=template&id=6f65ec8a"
import script from "./Thought.vue?vue&type=script&lang=js"
export * from "./Thought.vue?vue&type=script&lang=js"

import "./Thought.vue?vue&type=style&index=0&id=6f65ec8a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__